import React, { useState } from 'react';
// If using react-router-dom in a full application, you would import useNavigate like this:
import { useNavigate } from 'react-router-dom'; // Uncommented for demonstration

const App = () => {
  const today = new Date().toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });

  const profilePicPlaceholder = "https://placehold.co/32x32/AE7D54/ffffff?text=User";

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  // Using a placeholder for loggedInUser state.
  // In a real scenario with your XAMPP backend, this would be set after a successful API login.
  const [loggedInUser, setLoggedInUser] = useState({ username: 'Admin User' }); // Default to logged in for demonstration
  const [message, setMessage] = useState('');
  const [showMessageBox, setShowMessageBox] = useState(false);

  // If using react-router-dom, you would initialize it here:
  const navigate = useNavigate(); // Uncommented for demonstration

  const handleProfileClick = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  const showCustomMessage = (msg, isError = false) => {
    setMessage(msg);
    setShowMessageBox(true);
    setTimeout(() => {
      setShowMessageBox(false);
      setMessage('');
    }, 3000); // Message box disappears after 3 seconds
  };

  const handleLogout = () => {
    // This now simulates a client-side logout by clearing the user state.
    // In a real application with your XAMPP backend, you would send a request
    // to your backend to invalidate the session/token and then clear this state.
    setLoggedInUser(null); // Clear the logged-in user
    showCustomMessage("Logged out successfully!");
    setShowProfileMenu(false); // Close menu after logout
    // ✅ This line would redirect to the LoginForm route in a full react-router-dom setup.
    // In this isolated Canvas environment, actual navigation won't occur.
    navigate('/');
  };

  return (
    <>
      {/* CSS Styles */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

        body {
            font-family: 'Inter', sans-serif;
            margin: 0;
            background-color: #f3f4f6;
        }

        .top-nav-container {
          min-height: fit-content;
          display: flex;
          align-items: flex-start;
          justify-content: center;
          padding: 0;
        }

        .main-content-wrapper {
          width: 100%;
          max-width: 100%;
          background-color: white;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
          border-radius: 0;
          /* Removed overflow: hidden; to ensure profile menu is not clipped */
          display: flex;
          flex-direction: column;
          border-bottom: none;
        }

        .top-nav-row-one {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 1.5rem;
          border-bottom: none;
        }

        .search-box {
          display: flex;
          align-items: center;
          background-color: #f9fafb;
          padding: 0.5rem 1rem;
          border-radius: 0.5rem;
          color: #6b7280;
          width: 100%;
          max-width: 20rem;
        }

        @media (min-width: 640px) {
          .search-box {
            width: 20rem;
          }
        }

        @media (min-width: 768px) {
          .search-box {
            width: 24rem;
          }
        }

        .search-icon {
          height: 1.25rem;
          width: 1.25rem;
          margin-right: 0.5rem;
          color: #6b7280;
        }

        .search-input {
          border: none;
          background: transparent;
          flex-grow: 1;
          outline: none;
          font-size: 0.875rem;
          color: #374151;
        }

        .search-input::placeholder {
          color: #9ca3af;
        }

        .bell-profile-group {
          display: flex;
          align-items: center;
          gap: 1.25rem;
          margin-left: auto;
          position: relative;
        }

        .bell-icon {
          height: 1.5rem;
          width: 1.5rem;
          color: #4b5563;
          cursor: pointer;
          transition: color 0.2s ease-in-out;
        }

        .bell-icon:hover {
          color: #1f2937;
        }

        .profile-pic {
          width: 2rem;
          height: 2rem;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #d1d5db;
          cursor: pointer;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        }

        .profile-menu {
          position: absolute;
          top: calc(100% + 10px);
          right: 0;
          background-color: white;
          border-radius: 0.5rem;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          padding: 0.75rem 0;
          z-index: 9999; /* Increased z-index significantly for guaranteed top view */
          min-width: 150px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          transform-origin: top right;
          animation: fadeInScale 0.2s ease-out;
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.95);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .profile-menu-username {
            font-weight: 600;
            padding: 0.5rem 1rem;
            color: #1f2937;
            font-size: 0.9rem;
            margin-bottom: 0.5rem;
            width: calc(100% - 2rem);
            word-break: break-word;
        }

        .profile-menu-logout-btn {
            width: calc(100% - 2rem);
            padding: 0.75rem 1rem;
            background-color: #f87171;
            color: white;
            border: none;
            border-radius: 8px;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s ease-in-out;
            margin: 0 1rem 0.5rem;
        }

        .profile-menu-logout-btn:hover {
            background-color: #ef4444;
        }

        .top-nav-row-two {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 1.5rem;
          flex-wrap: wrap;
        }

        .date-text {
          color: #4b5563;
          font-size: 0.875rem;
          font-weight: 500;
          white-space: nowrap;
          flex-grow: 1;
          text-align: center;
        }

        @media (max-width: 639px) {
            .top-nav-row-two {
                flex-direction: column;
                align-items: center;
                gap: 0.75rem;
            }
            .date-text {
                text-align: center;
                flex-grow: 0;
            }
        }

        .booking-btn {
          background-color: #AE7D54;
          color: white;
          padding: 0.5rem 1.25rem;
          border: none;
          border-radius: 0.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s ease-in-out;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
        }

        .booking-btn:hover {
          background-color: #946746;
        }

        /* Message Box Styles */
        .message-box {
          position: fixed;
          top: 20px;
          left: 50%;
          transform: translateX(-50%);
          background-color: #4CAF50;
          color: white;
          padding: 15px 25px;
          border-radius: 8px;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
        }

        .message-box.show {
          opacity: 1;
          visibility: visible;
        }

        .message-box.error {
            background-color: #f44336;
        }
      `}</style>

      {/* React Component JSX */}
      <div className="top-nav-container">
        <div className="main-content-wrapper">
          {/* Top Row: Search Box, Bell Icon, Profile Picture */}
          <div className="top-nav-row-one">
            <div className="search-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="search-icon"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                />
              </svg>
              <input
                type="text"
                placeholder="Search for rooms and offers"
                className="search-input"
              />
            </div>

            <div className="bell-profile-group">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="bell-icon"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                />
              </svg>
              <img
                src={profilePicPlaceholder}
                alt="User"
                className="profile-pic"
                onClick={handleProfileClick}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://placehold.co/32x32/AE7D54/ffffff?text=Err";
                }}
              />
              {showProfileMenu && (
                <div className="profile-menu">
                  {loggedInUser ? (
                    <>
                      <span className="profile-menu-username">Welcome, {loggedInUser.username}</span>
                      <button className="profile-menu-logout-btn" onClick={handleLogout}>
                        Logout
                      </button>
                    </>
                  ) : (
                    <span className="profile-menu-username">User not logged in</span>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Bottom Row: Date and Create Booking Button */}
          
        </div>
      </div>

      {/* Custom Message Box */}
      {showMessageBox && (
        <div className={`message-box ${message.includes('Error') ? 'error' : ''} show`}>
          {message}
        </div>
      )}
    </>
  );
};

export default App;
